import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const ConfigContext = createContext({});

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({ razorpay_enabled: false, cod_fee: 49, free_ship_threshold: 2999, ship_fee: 99 });
  useEffect(() => {
    api.get("/config").then(({ data }) => setConfig(data)).catch(() => {});
  }, []);
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);
